export default {
    en: {
        createSuccess: 'Successfully created',
        editSuccess: 'Successfully updated',
        deleteSuccess: 'Successfully deleted',
    },
    zh: {
        createSuccess: '创建成功',
        editSuccess: '编辑成功',
        deleteSuccess: '删除成功',
    }
};
export const CreateStaff = {
    en: {
        placeHolder: {
            name: 'please input name',
            gender: '/'
        },
        label: {
            id: 'ID Number'
        }
    },
    zh: {
        placeHolder: {
            name: '请输入姓名',
            gender: '无'
        },
        label: {
            id: '身份证号（ID号）' //
        }
    },
};
